import { Eye, Plus, MoreHorizontal } from "lucide-react"
import { LightBtn, PrimaryBtn } from ".."
import Dropdown from "../dropdown"

interface IntegrationsPageHeaderActionsProps {
  isAdmin: boolean
  onOpenApprovedUrls: () => void
  onOpenApiKey: () => void
  onClickNew: () => void
}

export const IntegrationsPageHeaderActions = ({
  isAdmin,
  onOpenApprovedUrls,
  onOpenApiKey,
  onClickNew
}: IntegrationsPageHeaderActionsProps) => {
  if (!isAdmin) return null

  return (
    <>
      <LightBtn className="ml-3 hidden sm:flex" onClick={onOpenApprovedUrls}>
        Approved URL&apos;S
      </LightBtn>

      <LightBtn className="ml-3 hidden sm:flex" onClick={onOpenApiKey}>
        <Eye size={16} className="mr-1" /> API Key
      </LightBtn>

      <PrimaryBtn className="ml-3" onClick={onClickNew}>
        <Plus size={16} className="mr-1" /> New{" "}
        <span className="hidden sm:flex pl-1">Integration</span>
      </PrimaryBtn>

      <div className="flex sm:hidden ml-2 py-3 px-3 rounded-md border-black border">
        <Dropdown
          items={[
            { name: "Approved URL'S", onClick: onOpenApprovedUrls },
            { name: "API Key", onClick: onOpenApiKey }
          ]}
          menuBtn={<MoreHorizontal size={20} className="outline-none" />}
        />
      </div>
    </>
  )
}
